import CategoryBudget from './CategoryBudget'

export default CategoryBudget
